import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { OperationsRouteFactory } from "./operationsRouteContext";

const MissionsListScreen = lazyRouteComponent(
  () => import("../MissionsListScreen"),
  "MissionsListScreen",
);

export const createMissionsRoutes: OperationsRouteFactory = ({ context }) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/missions`,
    component: MissionsListScreen,
  }),
];
